import React, { useState } from 'react';
import { FiMenu, FiX } from 'react-icons/fi';
import { Link } from 'react-router-dom';
import './Navbar.css';

const Navbar = () => {
	const [open, setOpen] = useState(false);

	const handleClick = () => {
		setOpen(!open);
	};

	const closeMenu = () => {
		setOpen(false);
	};

	return (
		<nav className="navbar">
			<Link to="/" className="nav-logo">
			<img src='logoUDLA.png' alt='logoUdla' className="logo-udla"></img>
			</Link>
			<div onClick={handleClick} className="nav-icon">
				{open ? <FiX /> : <FiMenu />}
			</div>
			<ul className={open ? 'nav-links active' : 'nav-links'}>
				<li className="nav-item">
					<Link to="/" className="nav-link" onClick={closeMenu}>
						Inicio
					</Link>
				</li>
				<li className="nav-item">
					<Link to="/nosotros" className="nav-link" onClick={closeMenu}>
						Nosotros
					</Link>
				</li>
				<li className="nav-item">
					<Link to="/registro"  className="nav-link" onClick={closeMenu}>
						Registro
					</Link>
				</li>
				<li className="nav-item">
					<Link to="/login" className="nav-link nav-button" onClick={closeMenu}>
					 Login
					</Link>
				</li>
				
			</ul>
		</nav>
	);
};

export default Navbar;